import { FormControl, FormGroup } from '@angular/forms';
import { SearchModelV2 } from '../models/search-model-v2';

export const AppletAuditTrail: SearchModelV2 = {
  label: {
    tabelName: 'Table Name',
    ActionName: 'Action Name',
    actionBy: 'Action By',
    actionDate: 'Action Date'
  },
  dataType: {
    tabelName: 'string',
    ActionName: 'string',
    actionBy: 'string',
    actionDate: 'date'
  },
  form: new FormGroup({
    tabelName: new FormControl(),
    ActionName: new FormControl(),
    actionBy: new FormControl(),
    actionDate: new FormGroup({
      from: new FormControl(),
      to: new FormControl()
    }),
  }),
};

